/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=7d7d24be&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=7d7d24be&scoped=true&lang=less"

import exportComponent from "D:\\work\\官网\\yixindonghe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d7d24be"]])

export default __exports__